const en = {
  // Navigation
  nav: {
    products: 'SaaS Products',
    software: 'Software',
    services: 'Services',
    pricing: 'Pricing',
    resources: 'Resources',
    about: 'About',
    contact: 'Contact',
    login: 'Login',
    getStarted: 'Get Started',
    cmms: 'CMMS',
    cmmsDesc: 'Maintenance Management System',
    chatbot: 'AI Chatbot',
    chatbotDesc: 'Customer Support Automation',
    sfms: 'SFMS',
    sfmsDesc: 'Sports Facility Management System',
    gms: 'GMS',
    gmsDesc: 'Gym Management System',
    digitalTransformation: 'Digital Transformation',
    digitalTransformationDesc: 'Consulting & Strategy',
    customDevelopment: 'Custom Development',
    customDevelopmentDesc: 'Tailored Software Solutions',
    blog: 'Blog',
    blogDesc: 'Articles & Insights',
    docs: 'Documentation',
    docsDesc: 'Product Guides',
    help: 'Help Center',
    helpDesc: 'FAQs & Support',
    caseStudies: 'Case Studies',
    caseStudiesDesc: 'Success Stories',
  },

  // Hero Section
  hero: {
    badge: 'Trusted by companies worldwide',
    headline1: 'Transform Your Business with',
    headline2: 'Smart Solutions',
    subheadline: 'Enterprise-grade SaaS platform offering CMMS, AI-powered chatbots, digital transformation consulting, and custom software development.',
    feature1: 'Setup assistance included',
    feature2: 'Monthly or annual plans',
    feature3: 'Cancel anytime',
    ctaPrimary: 'Get Started',
    ctaSecondary: 'Watch Demo',
    trustedBy: 'Trusted by leading companies',
  
},

  // Products
  products: {
    title1: 'Our',
    title2: 'SaaS Products',
    subtitle: 'Choose from our powerful SaaS solutions designed to solve real business challenges',
    cmmsTitle: 'CMMS',
    cmmsSubtitle: 'Maintenance Management System',
    cmmsDesc: 'Streamline your maintenance operations with our comprehensive CMMS solution. Track assets, manage work orders, and optimize preventive maintenance schedules.',
    cmmsFeature1: 'Asset tracking & management',
    cmmsFeature2: 'Work order automation',
    cmmsFeature3: 'Preventive maintenance scheduling',
    cmmsFeature4: 'Inventory management',
    cmmsFeature5: 'Real-time dashboards & analytics',
    cmmsFeature6: 'Mobile app for technicians',
    cmmsPrice: 'Starting at $99/month',
    chatbotTitle: 'AI Chatbot',
    chatbotSubtitle: 'Customer Support Automation',
    chatbotDesc: 'Deploy intelligent AI-powered chatbots that provide 24/7 customer support. Train on your documents and website content for accurate, contextual responses.',
    chatbotFeature1: 'Natural language processing',
    chatbotFeature2: 'Document & website training',
    chatbotFeature3: 'Multi-language support',
    chatbotFeature4: 'Conversation analytics',
    chatbotFeature5: 'Easy website integration',
    chatbotFeature6: 'Customizable appearance',
    chatbotFeature7: 'Live human agent takeover',
    chatbotPrice: 'Starting at $49/month',
    startingAt: 'Starting at',
    learnMore: 'Learn More',
    viewPricing: 'View All Plans & Pricing',
  },

  // Services
  services: {
    title1: 'Professional',
    title2: 'Services',
    subtitle: 'Expert consulting and custom development to accelerate your digital journey',
    dtTitle: 'Digital Transformation Consulting',
    dtDesc: 'Transform your business with our expert consulting services. We help you leverage technology to optimize operations, enhance customer experience, and drive growth.',
    dtCap1: 'Strategy & Roadmap',
    dtCap2: 'Process Automation',
    dtCap3: 'Change Management',
    dtDeliverTitle: 'What We Deliver:',
    dtDeliver1: 'Comprehensive technology assessment',
    dtDeliver2: 'Digital strategy & roadmap development',
    dtDeliver3: 'Process optimization & automation',
    dtDeliver4: 'Change management support',
    dtDeliver5: 'ROI analysis & KPI tracking',
    dtCta: 'Schedule Free Consultation',
    dtPrice: 'Custom pricing based on scope',
    cdTitle: 'Custom Application Development',
    cdDesc: 'Get tailored software solutions built specifically for your business needs. Our expert team delivers high-quality web and mobile applications using modern technologies.',
    cdCap1: 'Full-Stack Development',
    cdCap2: 'Agile Methodology',
    cdCap3: 'Quality Assurance',
    cdDeliver1: 'Web & mobile app development',
    cdDeliver2: 'API development & integration',
    cdDeliver3: 'Legacy system modernization',
    cdDeliver4: 'Cloud infrastructure setup',
    cdDeliver5: 'Ongoing support & maintenance',
    cdCta: 'Request Project Quote',
    cdPrice: '',
    projects: 'Projects',
    satisfaction: 'Satisfaction',
    support: 'Support',
    notSure: 'Not sure which service fits your needs?',
    notSureDesc: 'Schedule a free consultation and let our experts guide you',
    contactUs: 'Contact Us Today',
  },

  // Features
  features: {
    title1: 'Why Choose',
    title2: 'mwbTechs',
    subtitle: 'Enterprise-grade features built for modern businesses',
    security: 'Enterprise Security',
    securityDesc: 'Bank-level encryption, SOC 2 compliance, and regular security audits to keep your data safe.',
    fast: 'Lightning Fast',
    fastDesc: 'Optimized performance with 99.9% uptime guarantee and sub-second response times.',
    collaboration: 'Team Collaboration',
    collaborationDesc: 'Role-based access control, real-time updates, and seamless team communication.',
    analytics: 'Advanced Analytics',
    analyticsDesc: 'Comprehensive dashboards, custom reports, and data-driven insights for better decisions.',
    multiLanguage: 'Multi-Language',
    multiLanguageDesc: 'Support for multiple languages with automatic translation and localization features.',
    privacy: 'Data Privacy',
    privacyDesc: 'GDPR compliant, data residency options, and complete control over your information.',
    support247: '24/7 Support',
    support247Desc: 'Round-the-clock customer support via chat, email, and phone with <2 hour response time.',
    mobile: 'Mobile Apps',
    mobileDesc: 'iOS and Android apps for on-the-go access from any device.',
    customers: 'Active Customers',
    uptime: 'Uptime SLA',
    users: 'Daily Users',
    supportAvailable: 'Support Available',
  },

  // Pricing
  pricing: {
    title1: 'Simple,',
    title2: 'Transparent Pricing',
    subtitle: 'Choose the perfect plan for your business.',
    monthly: 'Monthly',
    annual: 'Annual',
    save: 'Save 20%',
    cmmsPlans: 'CMMS Plans',
    chatbotPlans: 'AI Chatbot Plans',
    basic: 'Basic',
    pro: 'Pro',
    enterprise: 'Enterprise',
    popular: 'Most Popular',
    perMonth: '/month',
    billedAnnually: 'billed annually',
    startTrial: 'Get Started',
    contactSales: 'Contact Sales',
    viewDetailed: 'View Detailed Pricing & Features',
    extraSlots: 'Additional slots can be purchased separately',
    extraMessages: 'Extra message slots can be purchased separately',
    // eslint-disable-next-line no-template-curly-in-string -- literal "$" before an i18next placeholder
    extraMessagesRate: 'Extra messages: ${{price}} per 1,000',
  
    feat_unlimitedAssets: 'Unlimited assets',
    feat_assets: '{{n}} assets',
    feat_unlimitedUsers: 'Unlimited users',
    feat_users: '{{n}} users',
    feat_unlimitedLocations: 'Unlimited locations',
    feat_locations: '{{n}} locations',
    feat_unlimitedBranches: 'Unlimited branches',
    feat_branches: '{{n}} branches',
    feat_unlimitedMsgs: 'Unlimited messages/month',
    feat_msgs: '{{n}} messages/month',
    feat_unlimitedChatbots: 'Unlimited chatbots',
    feat_chatbots: '{{n}} chatbots',
    feat_chatbot: '{{n}} chatbot',
    feat_unlimitedDocs: 'Unlimited documents per chatbot',
    feat_docs: '{{n}} documents per chatbot',
    feat_doc: '{{n}} document per chatbot',
    feat_agents: '{{n}} live agents included',
    feat_agent: '{{n}} live agent included',
    feat_channels: 'WhatsApp, Instagram & Facebook',
    descBasicCmms: 'Perfect for small teams',
    descProCmms: 'Most popular for growing businesses',
    descEnterpriseCmms: 'For large organizations',
    descBasicChatbot: 'Great for small websites',
    descProChatbot: 'Best for growing businesses',
    descEnterpriseChatbot: 'For high-volume usage',
    feat_workOrders: 'Work order management',
    feat_basicReports: 'Basic reports',
    feat_emailSupport: 'Email support',
    feat_mobileApp: 'Mobile app access',
    feat_advWorkOrders: 'Advanced work orders',
    feat_preventive: 'Preventive maintenance',
    feat_inventory: 'Inventory management',
    feat_prioritySupport: 'Priority support',
    feat_customReports: 'Custom reports',
    feat_apiAccess: 'API access',
    feat_allPro: 'All Pro features',
    feat_customInteg: 'Custom integrations',
    feat_dedicatedMgr: 'Dedicated account manager',
    feat_phone247: '24/7 phone support',
    feat_advSecurity: 'Advanced security',
    feat_sla: 'SLA guarantee',
    feat_1website: '1 website crawl',
    feat_websites: '{{n}} website crawls',
    feat_basicAnalytics: 'Basic analytics',
    feat_advAnalytics: 'Advanced analytics',
    feat_customBranding: 'Custom branding',
    feat_unlimMsgs: 'Unlimited messages',
    feat_unlimDocs: 'Unlimited documents',
    feat_unlimCrawls: 'Unlimited crawls',
    feat_support247: '24/7 support',
    feat_whiteLabel: 'White-label solution',
},

  // Testimonials
  testimonials: {
    title1: 'Loved by',
    title2: 'Customers Worldwide',
    subtitle: 'See what our customers have to say about their experience',
    trustedBy: 'Trusted by leading brands worldwide',
  },

  // CTA
  cta: {
    title: 'Ready to Transform Your Business?',
    subtitle: 'Join the companies that trust mwbTechs for their digital transformation',
    feature1: 'Monthly or annual billing',
    feature2: 'Priority support',
    feature3: 'Cancel anytime',
    feature4: 'Setup assistance included',
    startTrial: 'Get Started',
    talkToSales: 'Talk to Sales',
    companies: 'Companies',
    activeUsers: 'Active Users',
    uptime: 'Uptime',
    support: 'Support',
  },

  // Footer
  footer: {
    description: 'Enterprise SaaS platform delivering innovative solutions for modern businesses. Transform your operations with our cutting-edge technology.',
    products: 'Products',
    software: 'Software',
    services: 'Services',
    resources: 'Resources',
    company: 'Company',
    newsletter: 'Subscribe to our newsletter',
    newsletterDesc: 'Get the latest updates, news, and exclusive offers delivered to your inbox.',
    emailPlaceholder: 'Enter your email',
    subscribe: 'Subscribe',
    subscribeSuccess: 'Thank you for subscribing! Check your inbox for a confirmation email.',
    subscribeError: 'Something went wrong. Please try again.',
    copyright: 'mwbTechs. All rights reserved.',
    linkCmms: 'CMMS',
    linkChatbot: 'AI Chatbot',
    linkSfms: 'SFMS',
    linkGms: 'GMS',
    linkPricing: 'Pricing',
    linkDigitalTransformation: 'Digital Transformation',
    linkCustomDevelopment: 'Custom Development',
    linkDocumentation: 'Documentation',
    linkHelpCenter: 'Help Center',
    linkCaseStudies: 'Case Studies',
    linkAboutUs: 'About Us',
    linkContact: 'Contact',
    linkPrivacy: 'Privacy Policy',
    linkTerms: 'Terms of Service',
    linkSecurity: 'Security',
  },

  // Contact
  contact: {
    title1: 'Get in',
    title2: 'Touch',
    subtitle: "Have a question or ready to start your project? We're here to help!",
    info: 'Contact Information',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    hours: 'Business Hours',
    monday: 'Monday - Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    closed: 'Closed',
    general: 'General Inquiry',
    consultation: 'Request Consultation',
    quote: 'Get Project Quote',
    success: 'Message sent successfully!',
    successDesc: "We'll get back to you within 24 hours.",
    name: 'Full Name',
    company: 'Company',
    message: 'Message',
    required: 'Required',
    service: 'Service Interested In',
    projectType: 'Project Type',
    budget: 'Budget Range',
    timeline: 'Timeline',
    send: 'Send Message',
    phoneHours: 'Mon-Fri 9am-6pm Beirut (EET)',
    companyPlaceholder: 'Company Name',
    messagePlaceholderGeneral: 'How can we help you?',
    messagePlaceholderConsultation: 'Tell us about your business challenges...',
    messagePlaceholderQuote: 'Please describe your project requirements...',
    selectService: 'Select a service...',
    serviceDigitalTransformation: 'Digital Transformation',
    serviceProcessAutomation: 'Process Automation',
    serviceStrategy: 'Digital Strategy',
    serviceChangeManagement: 'Change Management',
    selectProjectType: 'Select project type...',
    projectWebApp: 'Web Application',
    projectMobileApp: 'Mobile Application',
    projectApi: 'API Development',
    projectModernization: 'Legacy Modernization',
    projectCloud: 'Cloud Solutions',
    selectBudget: 'Select budget...',
    selectTimeline: 'Select timeline...',
    timelineAsap: 'ASAP',
    timeline1to3: '1-3 months',
    timeline3to6: '3-6 months',
    timeline6plus: '6+ months',
  },

  // Common
  common: {
    loading: 'Loading...',
    error: 'An error occurred',
    comingSoon: 'Coming Soon...',
  },

  login: {
    welcomeBack: 'Welcome Back!',
    signInDesc: 'Sign in to access your account and continue managing your operations efficiently.',
    quickAccessTitle: 'Quick Access To:',
    quickAccess1: 'Dashboard & Analytics',
    quickAccess2: 'Work Orders & Assets',
    quickAccess3: 'Chatbot Management',
    quickAccess4: 'Team Collaboration',
    quickAccess5: 'Reports & Insights',
    newUser: 'New to mwbTechs?',
    startTrialPromo: 'Create your account to get started with mwbTechs.',
    createAccount: 'Create Account',
    signIn: 'Sign In',
    signInSubtitle: 'Enter your credentials to access your account',
    emailAddress: 'Email Address',
    password: 'Password',
    forgotPassword: 'Forgot password?',
    rememberMe: 'Remember me for 30 days',
    signingIn: 'Signing in...',
    noAccount: "Don't have an account?",
    startFreeTrial: 'Create an account',
    loginFailed: 'Login Failed',
    verificationEmailSent: 'Verification email sent! Please check your inbox.',
    resendVerification: 'Resend verification email',
    sending: 'Sending...',
    twoFactor: 'Two-Factor Authentication',
    twoFactorDesc: 'Enter the code from your authenticator app',
    twoFactorHint: 'A verification code has been requested for',
    verificationFailed: 'Verification Failed',
    verificationCode: 'Verification Code',
    authenticatorHint: 'Open your authenticator app (Google Authenticator, Authy, etc.) and enter the 6-digit code.',
    verifying: 'Verifying...',
    verifySignIn: 'Verify & Sign In',
    troubleAuth: 'Having trouble with your authenticator app?',
    contactSupport: 'Contact Support',
    backToLogin: 'Back to login',
    enterSixDigit: 'Please enter a 6-digit code',
    invalidCode: 'Invalid verification code. Please try again.',
    emailRequired: 'Email is required',
    invalidEmail: 'Invalid email address',
    passwordRequired: 'Password is required',
  },

  signup: {
    title: 'Start Your Free Trial Today',
    subtitle: 'Join 2,000+ businesses transforming their operations with mwbTechs',
    benefit1: '14-day free trial, no credit card required',
    benefit2: 'Access to all features',
    benefit3: 'Priority support',
    benefit4: 'Cancel anytime',
    includedTitle: "What's Included:",
    included1: 'Full access to CMMS or AI Chatbot',
    included2: 'Unlimited users during trial',
    included3: 'Mobile app access',
    included4: 'Email support',
    included5: 'No credit card required',
    included6: 'Setup assistance included',
    stepAccount: 'Create Your Account',
    stepAccountDesc: 'Enter your details to get started',
    stepCompany: 'Company Information',
    stepCompanyDesc: 'Tell us about your organization',
    firstName: 'First Name',
    lastName: 'Last Name',
    emailAddress: 'Email Address',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    trialLabel: 'Start with 14-day free trial',
    trialDesc: 'No credit card required. Full access to all features.',
    continue: 'Continue',
    companyName: 'Company Name',
    industry: 'Industry',
    companySize: 'Company Size',
    selectSize: 'Select size',
    small: '1-50 employees',
    medium: '51-250 employees',
    large: '251-1000 employees',
    enterprise: '1000+ employees',
    phone: 'Phone',
    country: 'Country',
    timezone: 'Timezone',
    selectCountryFirst: 'Select a country first',
    servicesInterested: 'Which services are you interested in?',
    cmmsName: 'CMMS',
    cmmsDesc: 'Maintenance management system',
    chatbotName: 'AI Chatbot',
    chatbotDesc: 'Intelligent customer support bot',
    agreeTerms: 'I agree to the',
    termsOfService: 'Terms of Service',
    and: 'and',
    privacyPolicy: 'Privacy Policy',
    back: 'Back',
    startFreeTrial: 'Start Free Trial',
    creatingAccount: 'Creating Account...',
    alreadyHaveAccount: 'Already have an account?',
    signIn: 'Sign in',
    welcomeTitle: 'Welcome to mwbTechs!',
    welcomeDesc: 'Your account has been created successfully. Check your email for verification link.',
    goToLogin: 'Go to Login',
    selectService: 'Please select at least one service to continue.',
    firstNameRequired: 'First name is required',
    lastNameRequired: 'Last name is required',
    emailRequired: 'Email is required',
    invalidEmail: 'Invalid email address',
    passwordRequired: 'Password is required',
    passwordMinLength: 'Password must be at least 8 characters',
    confirmPasswordRequired: 'Please confirm password',
    passwordsMustMatch: 'Passwords do not match',
    companySizeRequired: 'Company size is required',
    companyNameRequired: 'Company name is required',
    acceptTerms: 'You must accept the terms',
  },

  auth: {
    verifyEmail: 'Verify Your Email',
    verifyDesc: 'We sent a verification link to your email address. Please check your inbox and click the link to activate your account.',
    verifyNote: "Didn't receive the email? Check your spam folder.",
    backToLogin: 'Back to Login',
    verifying: 'Verifying your email...',
    verifiedTitle: 'Email Verified!',
    verifiedDesc: 'Your email has been verified successfully. You can now sign in to your account.',
    goToLogin: 'Go to Login',
    failedTitle: 'Verification Failed',
    failedDesc: 'The verification link is invalid or has expired.',
    requestNew: 'Request New Link',
    forgotTitle: 'Forgot your password?',
    forgotDesc: "Enter your email address and we'll send you a link to reset your password.",
    emailAddress: 'Email address',
    sendResetLink: 'Send reset link',
    sending: 'Sending…',
    checkEmail: 'Check your email',
    checkEmailDesc: "If an account exists with that email address, we've sent a password reset link. Please check your inbox and spam folder.",
    backToLoginLink: 'Back to Login',
    resetTitle: 'Set new password',
    resetDesc: 'Choose a strong password for your account.',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    resetButton: 'Reset password',
    resetting: 'Resetting…',
    resetSuccess: 'Password reset!',
    resetSuccessDesc: 'Your password has been updated successfully. You can now log in with your new password.',
    invalidResetLink: 'Invalid reset link',
    invalidResetDesc: 'This password reset link is missing or invalid. Please request a new one.',
    requestNewLink: 'Request new link',
    passwordMin: 'Password must be at least 8 characters',
    passwordsNoMatch: 'Passwords do not match',
  },

  cmmsPage: {
    badge: 'Maintenance Management',
    heroTitle: 'Complete CMMS Solution for Modern Maintenance',
    heroSubtitle: 'Streamline maintenance operations, reduce downtime, and extend asset life with our comprehensive maintenance management system.',
    startFreeTrial: 'Get Started',
    scheduleDemo: 'Schedule Demo',
    watchWalkthrough: 'Watch Walkthrough',
    videoSectionBadge: 'Product Walkthrough',
    videoSectionTitle: 'See mwbTechs CMMS in Action',
    videoSectionSubtitle: 'Watch the full walkthrough and see how teams manage maintenance from day one.',
    lessDowntime: 'Less Downtime',
    fasterResponse: 'Faster Response',
    avgSavings: 'Avg Savings',
    featuresTitle: 'Powerful Features for Complete Maintenance Control',
    featuresSubtitle: 'Everything you need to manage maintenance operations efficiently',
    f1Title: 'Asset Management',
    f1Desc: 'Track and manage all your assets with detailed records, maintenance history, and lifecycle tracking.',
    f2Title: 'Preventive Maintenance',
    f2Desc: 'Schedule and automate preventive maintenance to reduce downtime and extend asset life.',
    f3Title: 'Inventory Control',
    f3Desc: 'Manage spare parts inventory with automatic reorder points and supplier integration.',
    f4Title: 'Real-time Analytics',
    f4Desc: 'Get instant insights with customizable dashboards and comprehensive reporting.',
    f5Title: 'Mobile Access',
    f5Desc: 'Technicians can access work orders, update status, and log time from anywhere.',
    f6Title: 'Work Order Management',
    f6Desc: 'Create, assign, and track work orders with priority levels and automated workflows.',
    useCasesTitle: 'Real Results Across Industries',
    useCasesSubtitle: 'See how companies are transforming maintenance operations',
    challenge: 'Challenge',
    solution: 'Solution',
    result: 'Result',
    uc1Industry: 'Manufacturing',
    uc1Challenge: 'Unplanned equipment downtime costing $50K/hour',
    uc1Solution: 'Implemented predictive maintenance schedules',
    uc1Result: '35% reduction in downtime, $2M annual savings',
    uc2Industry: 'Facilities Management',
    uc2Challenge: 'Manual paper-based work orders causing delays',
    uc2Solution: 'Digital work order system with mobile app',
    uc2Result: '60% faster response times, 40% cost reduction',
    uc3Industry: 'Healthcare',
    uc3Challenge: 'Equipment compliance and safety tracking',
    uc3Solution: 'Automated compliance tracking and alerts',
    uc3Result: '100% regulatory compliance, zero safety incidents',
    uc4Industry: 'Hospitality & Hotels',
    uc4Challenge: 'Handling maintenance requests across hundreds of rooms while avoiding guest disruption',
    uc4Solution: 'Room-based asset tracking with priority scheduling and real-time technician dispatch',
    uc4Result: '50% faster response to guest requests, measurable improvement in satisfaction scores',
    pricingTitle: 'Choose Your Plan',
    pricingSubtitle: 'Monthly or annual billing • Cancel anytime',
    monthly: 'Monthly',
    annual: 'Annual',
    save10: 'Save 10%',
    custom: 'Custom',
    perMonth: '/month',
    billedAnnually: 'billed annually',
    getStarted: 'Get Started',
    mostPopular: 'Most Popular',
    contactPricing: 'Contact us for pricing information.',
    getInTouch: 'Get in touch',
    ctaTitle: 'Ready to Transform Your Maintenance Operations?',
    ctaSubtitle: 'Join 500+ companies using our CMMS to reduce costs and improve efficiency',
  },

  chatbotPage: {
    badge: 'AI-Powered Customer Support',
    heroTitle: 'Intelligent Chatbot That Understands Your Customers',
    heroSubtitle: 'Deploy AI-powered chatbots that provide 24/7 customer support, answer questions instantly, and automatically escalate to live agents when needed.',
    tryItFree: 'Try It Free',
    seeDemo: 'See Demo',
    watchWalkthrough: 'Watch Walkthrough',
    videoSectionBadge: 'Product Walkthrough',
    videoSectionTitle: 'See mwbTechs Chatbot in Action',
    videoSectionSubtitle: 'Watch the full walkthrough and see how the chatbot handles real customer conversations.',
    benefitsTitle: 'Why Businesses Love Our AI Chatbot',
    b1Label: 'Availability',
    b1Desc: 'Never miss a customer inquiry',
    b2Label: 'Automation Rate',
    b2Desc: 'Handle most queries automatically',
    b3Label: 'Response Time',
    b3Desc: 'Instant answers, happy customers',
    b4Label: 'Cost Reduction',
    b4Desc: 'Lower support costs significantly',
    featuresTitle: 'Powerful Features for Modern Customer Support',
    featuresSubtitle: 'Everything you need to deliver exceptional customer experience',
    f1Title: 'AI-Powered Intelligence',
    f1Desc: 'Advanced NLP understands context, intent, and provides accurate, human-like responses.',
    f2Title: 'Multi-Language Support',
    f2Desc: 'Communicate with customers in 50+ languages with automatic translation.',
    f3Title: 'Instant Training',
    f3Desc: 'Train your chatbot on documents, websites, and FAQs in minutes.',
    f4Title: 'Conversation Analytics',
    f4Desc: 'Track metrics, identify trends, and continuously improve customer experience.',
    f5Title: 'Easy Integration',
    f5Desc: 'Simple embed code to add the chatbot to your website, app, or platform in minutes.',
    f6Title: 'Omnichannel Support',
    f6Desc: 'Deploy on website, mobile app, WhatsApp, Facebook Messenger, and more.',
    stepsTitle: 'Get Started in 3 Simple Steps',
    step1Title: 'Train Your Chatbot',
    step1Desc: 'Upload documents, add website URLs, or paste FAQs. Our AI learns your content instantly.',
    step2Title: 'Customize Appearance',
    step2Desc: 'Match your brand with custom colors, logo, and greeting messages.',
    step3Title: 'Deploy Anywhere',
    step3Desc: 'Add the simple embed code to your website and go live in minutes!',
    pricingTitle: 'Simple, Transparent Pricing',
    pricingSubtitle: 'Monthly or annual billing • Cancel anytime',
    monthly: 'Monthly',
    annual: 'Annual',
    save10: 'Save 10%',
    custom: 'Custom',
    perMonth: '/month',
    billedAnnually: 'billed annually',
    getStarted: 'Get Started',
    mostPopular: 'Most Popular',
    contactPricing: 'Contact us for pricing information.',
    getInTouch: 'Get in touch',
    startFreeTrial: 'Get Started',
    planFeatMessages: '{{count}} messages / month',
    planFeatDocsUnlimited: 'Unlimited documents / chatbot',
    planFeatDocs: '{{count}} documents / chatbot',
    planFeatAgentsUnlimited: 'Unlimited live agents',
    planFeatAgents: '{{count}} live agent included',
    planFeatAgentsPlural: '{{count}} live agents included',
    planFeatChannels: 'WhatsApp, Instagram & Facebook',
    liveAgentBadge: 'Live Agent Support',
    liveAgentTitle: 'AI Handles It First. Humans Step In When It Matters.',
    liveAgentSubtitle: 'When the AI reaches its limits, a real agent joins the conversation — instantly, with full context.',
    liveAgentDesc: 'Our chatbot monitors every conversation in real time. When it cannot resolve an issue or the visitor requests human help, it automatically triggers a handover to your agent team. Agents see the full conversation history, so customers never have to repeat themselves.',
    liveAgentB1: 'Auto-escalation when AI cannot resolve',
    liveAgentB2: 'Agents see full conversation history',
    liveAgentB3: 'Real-time agent inbox to manage live chats',
    liveAgentB4: 'Smooth handoff — zero disruption for visitors',
    ctaTitle: 'Ready to Automate Your Customer Support?',
    ctaSubtitle: 'Join businesses using AI chatbots and live agents to delight customers',
    seeInAction: 'See It In Action',
  },

  sfmsPage: {
    badge: 'Sports Facility Management',
    heroTitle: 'Every Venue, Member and Booking Record in One System',
    heroSubtitle: 'SFMS keeps your booking records, academy subscriptions, memberships, events and equipment in one place, with role-based access across every venue you run.',
    requestDemo: 'Request a Demo',
    seeDashboard: 'See the Dashboard',
    talkToSales: 'Talk to Sales',
    highlightsTitle: 'Built for venues of every size',
    h1: 'Booking records for every court, pitch and hall',
    h2: 'Academy subscriptions and memberships side by side',
    h3: 'Multiple venues under a single account',
    h4: 'Role-based access for every member of staff',
    previewTitle: 'See SFMS in Action',
    previewSubtitle: 'A look at the dashboard your team works in every day',
    previewCaption: 'SFMS — Dashboard',
    previewAlt: 'SFMS dashboard',
    previewPlaceholder: 'Dashboard screenshot goes here',
    featuresTitle: 'Everything Your Facility Needs in One Place',
    featuresSubtitle: 'From booking records and subscriptions to utilization reports',
    f1Title: 'Booking Records',
    f1Desc: 'Record and track every booking across your courts, pitches and halls, with the full history kept against each space.',
    f2Title: 'Academy Subscriptions',
    f2Desc: 'Enroll members in academy programs and keep terms, renewals and attendance up to date.',
    f3Title: 'Membership Management',
    f3Desc: 'Set up membership plans and keep validity periods, renewals and entitlements in order.',
    f4Title: 'Events',
    f4Desc: 'Plan tournaments, friendlies and one-off events, and see them alongside your regular bookings.',
    f5Title: 'Inventory',
    f5Desc: 'Keep a light inventory of equipment and supplies, with stock levels and movements per venue.',
    f6Title: 'Roles & Permissions',
    f6Desc: 'Role-based access control puts each staff member on exactly the screens and records their job needs.',
    f7Title: 'Multi-Venue',
    f7Desc: 'Run several venues from one account, each with its own spaces, staff and records.',
    f8Title: 'Reports & Utilization',
    f8Desc: 'See how each space is used across the week and plan staffing and opening hours around real demand.',
    ctaTitle: 'Ready to Run Your Facility From One System?',
    ctaSubtitle: 'See how SFMS brings booking records, subscriptions and venues together.',
  },

  gmsPage: {
    badge: 'Gym Management',
    heroTitle: 'Run Your Gym Without the Paperwork',
    heroSubtitle: 'GMS handles memberships, check-ins, class schedules and trainer rosters in one place, so your team can spend its time on members instead of spreadsheets.',
    requestDemo: 'Request a Demo',
    seeDashboard: 'See the Dashboard',
    talkToSales: 'Talk to Sales',
    highlightsTitle: 'Made for studios, gyms and chains',
    h1: 'Member profiles, plans and renewals',
    h2: 'Fast front-desk and self check-in',
    h3: 'Class and personal-training schedules',
    h4: 'Trainer rosters and member assignments',
    previewTitle: 'See GMS in Action',
    previewSubtitle: 'A look at the dashboard your team works in every day',
    previewCaption: 'GMS — Dashboard',
    previewAlt: 'GMS dashboard',
    previewPlaceholder: 'Dashboard screenshot goes here',
    featuresTitle: 'Everything You Need to Manage Your Gym',
    featuresSubtitle: 'Memberships, classes, staff and reporting in a single platform',
    f1Title: 'Membership Plans',
    f1Desc: 'Create monthly, annual and session-based plans, and keep renewals, freezes and cancellations under control.',
    f2Title: 'Check-In & Access',
    f2Desc: 'Check members in from the front desk or a self-service kiosk, and spot expired memberships before they walk in.',
    f3Title: 'Class Scheduling',
    f3Desc: 'Publish group classes with capacity limits, waitlists and member self-booking.',
    f4Title: 'Trainer Management',
    f4Desc: 'Assign trainers to classes and personal sessions and keep every schedule visible to the whole team.',
    f5Title: 'Billing & Payments',
    f5Desc: 'Collect recurring and one-off payments and track outstanding balances for each member.',
    f6Title: 'Member Insights',
    f6Desc: 'Track attendance, retention and plan mix on dashboards built for gym operators.',
    ctaTitle: 'Ready to Modernize Your Gym?',
    ctaSubtitle: 'Bring memberships, classes and payments into one system your whole team can use.',
  },

  pricingPage: {
    heroTitle1: 'Simple,',
    heroTitle2: 'Transparent Pricing',
    heroSubtitle: 'Choose the perfect plan for your business.',
    cmmsPlans: 'CMMS Plans',
    chatbotPlans: 'AI Chatbot Plans',
    monthly: 'Monthly',
    annual: 'Annual',
    save10: 'Save 10%',
    custom: 'Custom',
    perMonth: '/month',
    billedAnnually: 'billed annually',
    mostPopular: 'Most Popular',
    startFreeTrial: 'Get Started',
    contactPricing: 'Contact us for pricing information.',
    faqTitle: 'Frequently Asked Questions',
    faq1Q: 'Can I switch plans anytime?',
    faq1A: 'Yes! You can upgrade or downgrade your plan at any time. Changes take effect immediately.',
    faq2Q: 'What payment methods do you accept?',
    faq2A: 'We accept all major credit cards (Visa, MasterCard, Amex), PayPal, and bank transfers for annual plans.',
    faq3Q: 'Is there a free trial?',
    faq3A: "We don't offer a free trial. Request a demo instead and we'll walk you through the platform before you choose a plan.",
    faq4Q: 'Can I see the platform before I buy?',
    faq4A: "Yes. Request a demo and we'll give you a walkthrough based on how you plan to use the system.",
    faq5Q: 'Do you offer refunds?',
    faq5A: 'Yes, we offer a 30-day money-back guarantee on all plans.',
    faq6Q: 'Can I get a custom plan?',
    faq6A: 'Absolutely! Contact our sales team for custom enterprise solutions tailored to your needs.',
    ctaTitle: 'Ready to Get Started?',
    ctaSubtitle: "Request a demo and we'll help you choose the right plan.",
    contactSales: 'Contact Sales',
  },

  docsPage: {
    title: 'Documentation',
    subtitle: 'Everything you need to get the most out of mwbTechs',
    searchPlaceholder: 'Search documentation...',
    s1Title: 'Getting Started',
    s1Desc: 'Quick start guides and onboarding resources',
    s1l1: 'Installation',
    s1l2: 'First Steps',
    s1l3: 'Basic Configuration',
    s1l4: 'Tutorials',
    s2Title: 'Chatbot Guide',
    s2Desc: 'Create, configure, and embed your AI chatbot',
    s2l1: 'Creating a Chatbot',
    s2l2: 'Knowledge Base & RAG',
    s2l3: 'Website Integration',
    s2l4: 'Mobile App Integration',
    s2l5: 'REST API Integration',
    s2l6: 'WhatsApp Channel Setup',
    s2l7: 'Messenger Channel Setup',
    s2l8: 'Instagram Channel Setup',
    s3Title: 'CMMS Guide',
    s3Desc: 'Set up and manage your maintenance operations',
    s3l1: 'Getting Started',
    s3l2: 'Managing Assets',
    s3l3: 'Work Orders',
    s3l4: 'Preventive Maintenance',
    s3l5: 'Team & Permissions',
    s4Title: 'Video Tutorials',
    s4Desc: 'Step-by-step video walkthroughs',
    s4l1: 'Quick Tour',
    s4l2: 'Advanced Features',
    s4l3: 'Best Practices',
    s4l4: 'Troubleshooting',
    needHelpTitle: 'Need More Help?',
    needHelpSubtitle: 'Our support team is here to assist you',
    visitHelp: 'Visit Help Center',
    contactSupport: 'Contact Support',
  },

  dtPage: {
    badge: 'Strategic Consulting',
    heroTitle: 'Digital Transformation That Drives Real Results',
    heroSubtitle: 'Navigate digital change with confidence. We help organizations modernize operations, embrace technology, and achieve sustainable growth.',
    scheduleConsultation: 'Schedule Consultation',
    ourApproach: 'Our Approach',
    stat1Label: 'Transformations Completed',
    stat2Label: 'Client Satisfaction',
    stat3Label: 'Average Value Created',
    stat4Label: 'Years Experience',
    servicesTitle: 'Comprehensive Digital Transformation Services',
    servicesSubtitle: 'End-to-end support for your digital journey',
    keyDeliverables: 'Key Deliverables:',
    s1Title: 'Strategy & Assessment',
    s1Desc: 'Evaluate current state, identify opportunities, and develop comprehensive digital transformation roadmap.',
    s1d1: 'Digital maturity assessment',
    s1d2: 'Technology gap analysis',
    s1d3: 'Strategic roadmap',
    s1d4: 'ROI projections',
    s2Title: 'Process Optimization',
    s2Desc: 'Streamline operations, eliminate inefficiencies, and automate manual workflows.',
    s2d1: 'Process mapping',
    s2d2: 'Automation opportunities',
    s2d3: 'Workflow design',
    s2d4: 'KPI framework',
    s3Title: 'Technology Implementation',
    s3Desc: 'Deploy modern solutions, integrate systems, and migrate to cloud infrastructure.',
    s3d1: 'System selection',
    s3d2: 'Integration planning',
    s3d3: 'Cloud migration',
    s3d4: 'Training programs',
    methodologyTitle: 'Our Proven Methodology',
    methodologySubtitle: 'A structured approach that delivers results',
    p1Phase: '1. Discovery',
    p1Duration: '2-3 weeks',
    p1a1: 'Stakeholder interviews',
    p1a2: 'Current state analysis',
    p1a3: 'Goals alignment',
    p1a4: 'Pain points identification',
    p2Phase: '2. Strategy',
    p2Duration: '3-4 weeks',
    p2a1: 'Digital roadmap',
    p2a2: 'Technology selection',
    p2a3: 'Change management plan',
    p2a4: 'Budget & timeline',
    p3Phase: '3. Implementation',
    p3Duration: '8-12 weeks',
    p3a1: 'Solution deployment',
    p3a2: 'System integration',
    p3a3: 'Data migration',
    p3a4: 'User training',
    p4Phase: '4. Optimization',
    p4Duration: 'Ongoing',
    p4a1: 'Performance monitoring',
    p4a2: 'Continuous improvement',
    p4a3: 'User support',
    p4a4: 'ROI tracking',
    caseStudiesTitle: 'Success Stories',
    caseStudiesSubtitle: 'Real transformations, measurable results',
    challenge: 'Challenge',
    solution: 'Solution',
    results: 'Results',
    cs1Company: 'Manufacturing Corp',
    cs1Industry: 'Manufacturing',
    cs1Challenge: 'Paper-based processes causing delays and errors',
    cs1Solution: 'Digital workflow automation and IoT integration',
    cs1r1: '70% faster order processing',
    cs1r2: '90% reduction in errors',
    cs1r3: '$1.5M annual savings',
    cs1r4: '40% productivity increase',
    cs2Company: 'Retail Chain',
    cs2Industry: 'Retail',
    cs2Challenge: 'Disconnected systems and poor customer insights',
    cs2Solution: 'Unified commerce platform and analytics dashboard',
    cs2r1: '360° customer view',
    cs2r2: '25% sales increase',
    cs2r3: 'Real-time inventory',
    cs2r4: '50% faster checkout',
    cs3Company: 'Financial Services',
    cs3Industry: 'Finance',
    cs3Challenge: 'Legacy systems limiting innovation and agility',
    cs3Solution: 'Cloud migration and API-first architecture',
    cs3r1: '10x deployment speed',
    cs3r2: '60% cost reduction',
    cs3r3: 'Zero downtime',
    cs3r4: 'Scalable infrastructure',
    ctaTitle: 'Ready to Transform Your Business?',
    ctaSubtitle: 'Schedule a free consultation to discuss your digital transformation journey',
    scheduleFreeConsultation: 'Schedule Free Consultation',
    expertConsultants: 'Expert Consultants',
    successRate: 'Success Rate',
    avgValueCreated: 'ROI Driven Results',
  },

  cdPage: {
    badge: 'Custom Development',
    heroTitle: 'Build Software That Scales With Your Business',
    heroSubtitle: 'Expert development team ready to turn your vision into reality. From MVP to enterprise solutions.',
    requestQuote: 'Request Quote',
    viewPortfolio: 'View Portfolio',
    stat1Title: '200+ Projects Delivered',
    stat1Sub: 'Across 15+ industries',
    stat2Title: '98% Client Satisfaction',
    stat2Sub: 'Based on 150+ reviews',
    stat3Title: '4 Weeks Average Start',
    stat3Sub: 'From contract to development',
    servicesTitle: 'Complete Development Services',
    servicesSubtitle: 'End-to-end development with modern technologies',
    s1Title: 'Web Applications',
    s1Desc: 'Custom web apps built with modern frameworks for scalability and performance.',
    s2Title: 'Mobile Development',
    s2Desc: 'Native iOS/Android apps or cross-platform solutions for maximum reach.',
    s3Title: 'Cloud Solutions',
    s3Desc: 'Scalable cloud architecture and migration services for modern infrastructure.',
    s4Title: 'API Development',
    s4Desc: 'RESTful and GraphQL APIs for seamless system integration.',
    s5Title: 'Security & Compliance',
    s5Desc: 'Enterprise-grade security with compliance standards built-in.',
    s6Title: 'Performance Optimization',
    s6Desc: 'Speed up existing applications and optimize for scale.',
    processTitle: 'Our Development Process',
    processSubtitle: 'Agile methodology with proven results',
    pr1Step: 'Discovery',
    pr1Desc: 'Understand requirements, goals, and technical constraints',
    pr1Duration: '1-2 weeks',
    pr1d1: 'Requirements document',
    pr1d2: 'Technical specifications',
    pr1d3: 'Project timeline',
    pr1d4: 'Cost estimate',
    pr2Step: 'Design',
    pr2Desc: 'Create architecture, UX/UI designs, and development roadmap',
    pr2Duration: '2-3 weeks',
    pr2d1: 'System architecture',
    pr2d2: 'UI/UX mockups',
    pr2d3: 'Database schema',
    pr2d4: 'API design',
    pr3Step: 'Development',
    pr3Desc: 'Build solution with agile sprints and continuous integration',
    pr3Duration: '8-16 weeks',
    pr3d1: 'Working software',
    pr3d2: 'Code reviews',
    pr3d3: 'Sprint demos',
    pr3d4: 'Documentation',
    pr4Step: 'Testing',
    pr4Desc: 'Comprehensive QA, security testing, and performance optimization',
    pr4Duration: '2-3 weeks',
    pr4d1: 'Test reports',
    pr4d2: 'Bug fixes',
    pr4d3: 'Performance metrics',
    pr4d4: 'Security audit',
    pr5Step: 'Deployment',
    pr5Desc: 'Production deployment with monitoring and support setup',
    pr5Duration: '1 week',
    pr5d1: 'Live application',
    pr5d2: 'Deployment docs',
    pr5d3: 'Monitoring setup',
    pr5d4: 'Training',
    pr6Step: 'Support',
    pr6Desc: 'Ongoing maintenance, updates, and feature enhancements',
    pr6Duration: 'Ongoing',
    pr6d1: 'Bug fixes',
    pr6d2: 'Updates',
    pr6d3: 'New features',
    pr6d4: '24/7 support',
    portfolioTitle: 'Recent Projects',
    portfolioSubtitle: "Real solutions we've built for real businesses",
    pf1Title: 'Anatolia Gold Catalogue',
    pf1Desc: 'Backoffice and mobile app for gold retail shops, plus a factory app where client orders are assigned to employees based on manufacturing stage',
    pf2Title: 'Dr. Kashmar',
    pf2Desc: 'Multi-clinic management system for cosmetic dermatology across KSA and Beirut, with a backoffice portal and native iOS & Android mobile app',
    pf3Title: 'MT5 Bridge Integration',
    pf3Desc: 'Custom MetaTrader 5 bridge integration enabling seamless connectivity between brokers and trading infrastructure',
    investmentTitle: 'Investment Ranges',
    investmentSubtitle: 'Transparent pricing for every project size',
    pl1Name: 'MVP Development',
    pl1Desc: 'Perfect for startups and proof of concepts',
    pl2Name: 'Full Product',
    pl2Desc: 'Complete solution for growing businesses',
    pl3Name: 'Enterprise',
    pl3Desc: 'Large-scale solutions with dedicated team',
    mostPopular: 'Most Popular',
    getQuote: 'Get Quote',
    ctaTitle: 'Ready to Build Your Custom Solution?',
    ctaSubtitle: "Let's discuss your project and create something amazing together",
    requestFreeQuote: 'Request Free Quote',
  },

  aboutPage: {
    heroTitle1: 'Transforming Businesses Through',
    heroTitle2: 'Innovation',
    heroSubtitle: "We're on a mission to help businesses modernize their operations with intelligent software solutions that drive real results.",
    getInTouch: 'Get in Touch',
    startFreeTrial: 'Get Started',
    stat1Label: 'Customers Worldwide',
    stat2Label: 'Active Users',
    stat3Label: 'Customer Satisfaction',
    stat4Label: 'Support Available',
    storyTitle: 'Our Story',
    storyP1: 'Founded in 2018, mwbTechs started with a simple observation: businesses were struggling with outdated maintenance management systems that hindered productivity and increased costs.',
    storyP2: "Our founders, a team of engineers and business leaders with decades of combined experience, saw an opportunity to revolutionize how companies manage their operations. We built our first CMMS solution with a focus on simplicity, power, and user experience.",
    storyP3: "Today, we serve over 2,000 businesses globally, from small teams to Fortune 500 companies. We've expanded our offerings to include AI-powered chatbots, digital transformation consulting, and custom development services.",
    storyP4: 'But our core mission remains the same: help businesses operate more efficiently through innovative technology solutions.',
    countriesServed: 'Countries Served',
    industryAwards: 'Industry Awards',
    teamMembers: 'Team Members',
    yoyGrowth: 'YoY Growth',
    valuesTitle: 'Our Values',
    valuesSubtitle: 'The principles that guide everything we do',
    v1Title: 'Innovation First',
    v1Desc: 'We constantly push boundaries to deliver cutting-edge solutions that drive real business value.',
    v2Title: 'Customer Success',
    v2Desc: "Your success is our success. We're committed to helping you achieve your goals.",
    v3Title: 'Collaboration',
    v3Desc: 'We believe in the power of teamwork, both internally and with our clients.',
    v4Title: 'Excellence',
    v4Desc: 'We maintain the highest standards in everything we do, from code to customer service.',
    teamTitle: 'Leadership Team',
    teamSubtitle: 'Experienced leaders passionate about innovation',
    timelineTitle: 'Our Journey',
    timelineSubtitle: 'Key milestones in our growth story',
    m1Event: 'Company Founded',
    m1Desc: 'Started with a vision to transform maintenance management',
    m2Event: 'First 100 Customers',
    m2Desc: 'Reached milestone of 100 happy customers across 10 industries',
    m3Event: 'Series A Funding',
    m3Desc: 'Raised $10M to accelerate product development',
    m4Event: 'AI Chatbot Launch',
    m4Desc: 'Launched revolutionary AI-powered customer support solution',
    m5Event: 'Global Expansion',
    m5Desc: 'Expanded operations to Europe and Asia-Pacific',
    m6Event: '1,000+ Customers',
    m6Desc: 'Crossed 1,000 customers milestone with 98% satisfaction rate',
    m7Event: 'Industry Recognition',
    m7Desc: 'Named Leader in Gartner Magic Quadrant',
    m8Event: 'Continued Growth',
    m8Desc: 'Serving 2,000+ businesses globally with 50K+ active users',
    ctaTitle: 'Join Our Journey',
    ctaSubtitle: 'Be part of the future of business operations',
    contactUs: 'Contact Us',
  },
  chatbotDocs: {
    breadcrumb: 'Documentation',
    title: 'Chatbot Integration Guide',
    heroSubtitle: 'Create your AI chatbot, build its knowledge base, and embed it on your website or mobile app — step by step.',
    onThisPage: 'On this page',
    toc_create: 'Creating a Chatbot',
    toc_kb: 'Knowledge Base & RAG',
    toc_website: 'Website Integration',
    toc_mobile: 'Mobile App Integration',
    toc_api: 'REST API Integration',
    toc_whatsapp: 'WhatsApp Channel Setup',
    toc_messenger: 'Messenger Channel Setup',
    toc_instagram: 'Instagram Channel Setup',
    s1_title: 'Creating a Chatbot',
    s1_subtitle: 'Set up your chatbot in the Customer Portal in minutes.',
    s1_step1: 'Log in to the Customer Portal and navigate to the Chatbot section from the sidebar.',
    s1_step2: 'Click "Create New Chatbot" and fill in the basic details.',
    s1_step3: 'Configure the appearance and behaviour settings:',
    s1_field: 'Field',
    s1_fieldDesc: 'Description',
    s1_fname: 'Name',
    s1_fnameDesc: 'Internal label for this chatbot',
    s1_fBotName: 'Bot Name',
    s1_fBotNameDesc: 'Display name shown to visitors',
    s1_fWelcome: 'Welcome Message',
    s1_fWelcomeDesc: 'First message the visitor sees when the chat opens',
    s1_fPrompt: 'System Prompt',
    s1_fPromptDesc: 'Instructions that shape the AI\'s personality and scope',
    s1_fColor: 'Primary Color',
    s1_fColorDesc: 'Accent color for the chat widget (hex code)',
    s1_fPosition: 'Position',
    s1_fPositionDesc: 'Where the widget appears: bottom-right or bottom-left',
    s1_note: 'After saving, you\'ll be shown your Chatbot ID and the embed code. Keep the Chatbot ID handy — you\'ll need it for the integration steps below.',
    s2_title: 'Knowledge Base & RAG',
    s2_subtitle: 'Feed your chatbot with documents, website pages, and live API data.',
    s2_intro: 'Open the chatbot\'s Knowledge Base modal (gear icon → Knowledge Base). You can add content from three sources:',
    s2_docs: 'Uploaded Documents',
    s2_docsDesc: 'Upload PDF, DOCX, or TXT files. The platform extracts text, splits it into chunks, and stores vector embeddings so the AI can retrieve relevant passages.',
    s2_docsSupported: 'Supported: PDF, DOCX, TXT, HTML',
    s2_urls: 'Website URLs',
    s2_urlsDesc: 'Paste a URL and the platform crawls and indexes the page text automatically. Useful for product pages, FAQs, or blog posts.',
    s2_apis: 'External APIs',
    s2_apisDesc: 'Connect live REST APIs (e.g. your e-commerce inventory). When a visitor asks a relevant question, the chatbot calls your API in real time and answers from the fresh JSON response.',
    s2_configFields: 'Configuration fields',
    s2_afName: 'Name',
    s2_afNameDesc: 'A short label, e.g. "Product Search"',
    s2_afDesc: 'Description',
    s2_afDescDesc: 'Tells the AI when to use this API, e.g. "Use when visitor asks about products or prices"',
    s2_afEndpoint: 'Endpoint URL',
    s2_afEndpointDesc: 'Full URL; add {query} placeholder for search, or omit it to fetch a full list',
    s2_afAuthName: 'Auth Header Name',
    s2_afAuthNameDesc: 'Optional — e.g. X-Shopify-Access-Token',
    s2_afAuthValue: 'Auth Header Value',
    s2_afAuthValueDesc: 'Optional — stored AES-256 encrypted',
    s2_urlExamples: 'URL examples',
    s2_note: 'Use Test & Save to verify the endpoint is reachable before saving. Up to 5 external APIs per chatbot.',
    s3_title: 'Website Integration',
    s3_subtitle: 'Add the chat widget to any website with a single script tag.',
    s3_step1: 'Copy your Chatbot ID from the Customer Portal (visible on the chatbot card or in the embed section).',
    s3_step2: 'Paste the script tag below into your HTML, just before the closing </body> tag.',
    s3_step3: 'Adjust the data-* attributes to match your chatbot\'s settings.',
    s3_attrRef: 'Attribute reference',
    s3_attrAttr: 'Attribute',
    s3_attrRequired: 'Required',
    s3_attrDesc: 'Description',
    s3_attr1Req: '✅ Yes',
    s3_attr1Desc: 'Unique ID of your chatbot',
    s3_attr2Req: '✅ Yes',
    s3_attr2Desc: 'Base URL of the chatbot backend',
    s3_attr3Req: 'Optional',
    s3_attr3Desc: 'Hex color for the widget accent (#007bff)',
    s3_attr4Req: 'Optional',
    s3_attr4Desc: 'bottom-right (default) or bottom-left',
    s3_attr5Req: 'Optional',
    s3_attr5Desc: 'Opening message shown to the visitor',
    s3_attr6Req: 'Optional',
    s3_attr6Desc: 'Display name for the AI assistant',
    s4_title: 'Mobile App Integration',
    s4_subtitle: 'Embed the chat widget in a React Native app using WebView.',
    s4_step1: 'Install the WebView package:',
    s4_step2: 'Create a ChatbotWidget component. Replace YOUR_CHATBOT_ID and your-platform.com with your values.',
    s4_step3: 'Mount the component at the root of your app (inside your auth provider so it only shows when logged in):',
    s4_platformNotes: 'Platform notes',
    s4_pAndroid: 'Android Emulator',
    s4_pAndroidDesc: 'Use 10.0.2.2 as the host instead of localhost (emulator maps 10.0.2.2 → your machine)',
    s4_pDevice: 'Physical Device',
    s4_pDeviceDesc: 'Use your machine\'s LAN IP (e.g. 192.168.1.x) so the device can reach your dev server',
    s4_pIOS: 'iOS Simulator',
    s4_pIOSDesc: 'localhost works directly',
    s4_pProd: 'Production',
    s4_pProdDesc: 'Use your real HTTPS domain — no changes needed',
    s5_title: 'REST API Integration',
    s5_subtitle: 'Call the chat API directly from any backend, mobile app, or custom UI — no widget required.',
    s5_intro: 'Every chatbot exposes the same REST endpoint. Two authentication methods are supported: the Widget Key (X-Widget-Key header, safe for browser/widget use) and a secret API Key (Authorization: Bearer header, for secure server-side integrations). Generate the API Key from the chatbot settings in the Customer Portal.',
    s5_auth: 'Authentication',
    s5_authDesc: 'Choose the method that matches your use case: X-Widget-Key for the embedded widget, or Authorization: Bearer <api-key> for server-side custom integrations (generate the key in chatbot settings).',
    s5_sendMsg: 'Send a Message',
    s5_reqHeaders: 'Request headers',
    s5_reqBody: 'Request body (JSON)',
    s5_field: 'Field',
    s5_required: 'Required',
    s5_fSessionIdDesc: 'Unique conversation ID — generate a UUID per conversation',
    s5_fMessageDesc: 'The user\'s message text',
    s5_fVisitorIdDesc: 'Your internal user/visitor identifier',
    s5_fVisitorEmailDesc: 'Visitor e-mail — stored on the conversation record',
    s5_fVisitorNameDesc: 'Visitor display name',
    s5_fMediaUrlDesc: 'URL of a media file to attach to the message (image, audio, document)',
    s5_fChannelTypeDesc: '"WIDGET" (default) or "WHATSAPP" — identifies which channel is sending',
    s5_fChannelSenderIdDesc: 'WhatsApp sender ID (wa_id) — required when channelType is "WHATSAPP"',
    s5_codeExamples: 'Code Examples',
    s5_response: 'Response',
    s5_endConv: 'End a Conversation',
    s5_endConvDesc: 'Call this when the user closes the chat to mark the session as completed.',
    s5_note: 'The Widget Key is public and safe to embed in browser code. The API Key (Bearer token) is for server-side use only — keep it secret and never include it in frontend or mobile app code.',
    s6_title: 'WhatsApp Channel Setup',
    s6_subtitle: 'Route WhatsApp Business messages through your AI chatbot and live agents.',
    s6_intro: 'The WhatsApp integration uses the Meta WhatsApp Business API (Cloud API). You connect your own Meta Business account — Meta bills you directly for any conversation fees beyond the free tier.',
    s6_prereqs: 'Prerequisites',
    s6_p1: 'Meta Business Account',
    s6_p1Desc: 'A verified Meta Business Manager account at business.facebook.com',
    s6_p2: 'Meta Developer App',
    s6_p2Desc: 'A Meta App with the WhatsApp Business API product added (developers.facebook.com)',
    s6_p3: 'Verified Phone Number',
    s6_p3Desc: 'A WhatsApp Business phone number added and verified inside your Meta App',
    s6_p4: 'Permanent Access Token',
    s6_p4Desc: 'A System User access token with whatsapp_business_messaging permission',
    s6_step1Title: 'Step 1 — Add a Channel in the Portal',
    s6_step1_1: 'In the Customer Portal, open your chatbot and scroll to the WhatsApp Channels section.',
    s6_step1_2: 'Click "Add Channel" and fill in the four fields:',
    s6_fField: 'Field',
    s6_fWhere: 'Where to find it',
    s6_fDispName: 'Display Name',
    s6_fDispNameDesc: 'Any label, e.g. "Customer Support WhatsApp"',
    s6_fPhoneId: 'Phone Number ID',
    s6_fPhoneIdDesc: 'Meta App → WhatsApp → API Setup → Phone Number ID',
    s6_fToken: 'Access Token',
    s6_fTokenDesc: 'Meta App → System Users → your system user → Generate Token (stored encrypted)',
    s6_fWebhookToken: 'Webhook Verify Token',
    s6_fWebhookTokenDesc: 'A secret string you invent — you will enter the same value in Meta',
    s6_step1Note: 'After saving, the portal displays your Webhook URL. Copy it — you need it in the next step.',
    s6_step2Title: 'Step 2 — Configure the Webhook in Meta',
    s6_step2_1: 'In your Meta App dashboard, go to WhatsApp → Configuration.',
    s6_step2_2: 'Under Webhook, click Edit and enter the Webhook URL copied from the portal.',
    s6_step2_3: 'Enter your Webhook Verify Token (the same string you used in Step 1).',
    s6_step2_4: 'Click "Verify and Save". Meta will call your webhook to confirm it responds correctly.',
    s6_step2_5: 'Subscribe to the "messages" webhook event so Meta sends you incoming messages.',
    s6_howTitle: 'How It Works',
    s6_how1: 'A customer messages your WhatsApp Business number.',
    s6_how2: 'Meta delivers the message to your webhook URL.',
    s6_how3: 'The chatbot processes it through the same AI pipeline used by the website widget.',
    s6_how4: 'The AI reply is sent back to the customer via Meta\'s Graph API.',
    s6_how5: 'If the chatbot triggers agent handover, the conversation appears in the Live Inbox. When an agent replies, the message is automatically delivered to the customer over WhatsApp.',
    s6_billing: 'Billing: Meta offers 1,000 free service conversations per month per WhatsApp Business Account. Beyond that, Meta charges per conversation based on your country tier. These charges are billed directly to your Meta Business account — not through this platform.',
    s7_title: 'Messenger Channel Setup',
    s7_subtitle: 'Connect your Facebook Page to receive and reply to Messenger conversations through your AI chatbot and live agents.',
    s7_intro: 'The Messenger integration uses the Meta Messenger Platform API. You connect a Facebook Page you manage — your chatbot receives messages sent to that page via Messenger.',
    s7_prereqs: 'Prerequisites',
    s7_p1: 'Meta Business Account',
    s7_p1Desc: 'A verified Meta Business Manager account at business.facebook.com',
    s7_p2: 'Facebook Page',
    s7_p2Desc: 'A Facebook Page you administer (the page users message)',
    s7_p3: 'Meta Developer App',
    s7_p3Desc: 'A Meta App with the Messenger product added (developers.facebook.com)',
    s7_p4: 'Page Access Token',
    s7_p4Desc: 'A permanent Page Access Token with pages_messaging permission',
    s7_step1Title: 'Step 1 — Add a Channel in the Portal',
    s7_step1_1: 'In the Customer Portal, open your chatbot and scroll to the Messaging Channels section.',
    s7_step1_2: 'Click the Messenger tab, then click "Add Channel" and fill in the four fields:',
    s7_fField: 'Field',
    s7_fWhere: 'Where to find it',
    s7_fDispName: 'Display Name',
    s7_fDispNameDesc: 'Any label, e.g. "Company Messenger"',
    s7_fPageId: 'Facebook Page ID',
    s7_fPageIdDesc: 'Your Facebook Page → About → Page ID (numeric)',
    s7_fToken: 'Access Token',
    s7_fTokenDesc: 'Meta App → Messenger → API Setup → Generate Token (stored encrypted)',
    s7_fWebhookToken: 'Webhook Verify Token',
    s7_fWebhookTokenDesc: 'A secret string you invent — you will enter the same value in Meta',
    s7_step2Title: 'Step 2 — Configure the Webhook in Meta',
    s7_step2_1: 'In your Meta App dashboard, go to Messenger → Settings → Webhooks.',
    s7_step2_2: 'Click Edit and enter the Webhook URL copied from the portal.',
    s7_step2_3: 'Enter your Webhook Verify Token (the same string you used in Step 1).',
    s7_step2_4: 'Subscribe to the messages field and click "Verify and Save".',
    s7_step2_5: 'Under Subscriptions, add your Facebook Page so it uses this webhook.',
    s7_howTitle: 'How It Works',
    s7_how1: 'A customer sends a message to your Facebook Page via Messenger.',
    s7_how2: 'Meta delivers the message to your webhook URL.',
    s7_how3: 'The chatbot processes it through the same AI pipeline used by the website widget.',
    s7_how4: 'The AI reply is sent back to the customer via Meta\'s Graph API.',
    s7_how5: 'If the chatbot triggers agent handover, the conversation appears in the Live Inbox. When an agent replies, the message is automatically delivered to the customer over Messenger.',
    s7_billing: 'Billing: The Messenger API is currently free for standard messaging. Meta may introduce fees in the future. Any charges are billed directly to your Meta Business account — not through this platform.',
    s8_title: 'Instagram Channel Setup',
    s8_subtitle: 'Connect your Instagram Business Account to receive and reply to Instagram Direct Messages through your AI chatbot and live agents.',
    s8_intro: 'The Instagram DM integration uses the Meta Instagram Messaging API. Your Instagram Business Account must be connected to a Facebook Page in Meta Business Suite.',
    s8_prereqs: 'Prerequisites',
    s8_p1: 'Instagram Business Account',
    s8_p1Desc: 'An Instagram account converted to a Business or Creator account',
    s8_p2: 'Linked Facebook Page',
    s8_p2Desc: 'The Instagram account must be connected to a Facebook Page in Meta Business Suite',
    s8_p3: 'Meta Developer App',
    s8_p3Desc: 'A Meta App with the Instagram Messaging product added',
    s8_p4: 'Page Access Token',
    s8_p4Desc: 'A permanent Page Access Token for the linked Facebook Page with instagram_manage_messages permission',
    s8_step1Title: 'Step 1 — Add a Channel in the Portal',
    s8_step1_1: 'In the Customer Portal, open your chatbot and scroll to the Messaging Channels section.',
    s8_step1_2: 'Click the Instagram tab, then click "Add Channel" and fill in the four fields:',
    s8_fField: 'Field',
    s8_fWhere: 'Where to find it',
    s8_fDispName: 'Display Name',
    s8_fDispNameDesc: 'Any label, e.g. "Company Instagram"',
    s8_fAccountId: 'Instagram Account ID',
    s8_fAccountIdDesc: 'Meta App → Instagram → API Setup → Instagram Business Account ID (numeric)',
    s8_fToken: 'Access Token',
    s8_fTokenDesc: 'Page Access Token for the linked Facebook Page (stored encrypted)',
    s8_fWebhookToken: 'Webhook Verify Token',
    s8_fWebhookTokenDesc: 'A secret string you invent — you will enter the same value in Meta',
    s8_step2Title: 'Step 2 — Configure the Webhook in Meta',
    s8_step2_1: 'In your Meta App dashboard, go to Instagram → Settings → Webhooks.',
    s8_step2_2: 'Click Edit and enter the Webhook URL copied from the portal.',
    s8_step2_3: 'Enter your Webhook Verify Token (the same string you used in Step 1).',
    s8_step2_4: 'Subscribe to the messages field and click "Verify and Save".',
    s8_step2_5: 'Ensure your Instagram Business Account is linked to the subscribed Page.',
    s8_howTitle: 'How It Works',
    s8_how1: 'A customer sends a Direct Message to your Instagram Business Account.',
    s8_how2: 'Meta delivers the message to your webhook URL.',
    s8_how3: 'The chatbot processes it through the same AI pipeline used by the website widget.',
    s8_how4: 'The AI reply is sent back to the customer via Meta\'s Graph API.',
    s8_how5: 'If the chatbot triggers agent handover, the conversation appears in the Live Inbox. When an agent replies, the message is automatically delivered to the customer over Instagram DM.',
    s8_note: 'Note: Instagram DM automation requires your app to be approved for the instagram_manage_messages permission in Meta\'s App Review. Test using your own accounts during development. Any Meta charges are billed directly to your Meta Business account.',
    needHelp: 'Need Help?',
    needHelpSubtitle: 'Our support team is ready to assist you with your integration.',
    backToDocs: '← Back to Docs',
    contactSupport: 'Contact Support',
  },
  cmmsDocs: {
    breadcrumb: 'Documentation',
    breadcrumbPage: 'CMMS Guide',
    title: 'CMMS User Guide',
    heroSubtitle: 'Set up your maintenance management system, manage assets, schedule preventive maintenance, and keep your team aligned — step by step.',
    onThisPage: 'On this page',
    toc_start: 'Getting Started',
    toc_assets: 'Managing Assets',
    toc_wo: 'Work Orders',
    toc_pm: 'Preventive Maintenance',
    toc_inv: 'Inventory & Warehouses',
    toc_team: 'Team & Permissions',
    toc_reports: 'Reports & Analytics',
    s1_title: 'Getting Started',
    s1_subtitle: 'Log in to the Customer Portal and activate your CMMS subscription.',
    s1_step1: 'Log in to the Customer Portal and navigate to Products.',
    s1_step2: 'Select the CMMS plan that fits your team size and click Subscribe.',
    s1_step3: 'Once active, the CMMS section appears in the left sidebar.',
    s1_step4: 'Go to CMMS → Dashboard for an overview of your operations.',
    s1_keyConcepts: 'Key concepts',
    s1_branch: 'Branch',
    s1_branchDesc: 'A physical site or location your company operates (e.g. a factory or office)',
    s1_asset: 'Asset',
    s1_assetDesc: 'Any equipment or item you want to track and maintain',
    s1_wo: 'Work Order',
    s1_woDesc: 'A task assigned to a technician to repair or service an asset',
    s1_pm: 'PM Schedule',
    s1_pmDesc: 'A recurring maintenance task that runs automatically on a schedule',
    s1_inv: 'Inventory',
    s1_invDesc: 'Spare parts and materials stored in your warehouses',
    s2_title: 'Managing Assets',
    s2_subtitle: 'Register and track all equipment in your branches.',
    s2_step1: 'Navigate to CMMS → Assets and click Add Asset.',
    s2_step2: 'Fill in the asset details — name, category, branch, and location.',
    s2_step3: 'Optionally add components (sub-parts) with their own maintenance intervals.',
    s2_step4: 'Attach photos, manuals, or warranty documents as needed.',
    s2_step5: 'Save the asset. It is now trackable and can be linked to work orders.',
    s2_assetFields: 'Asset fields',
    s2_fField: 'Field',
    s2_fDesc: 'Description',
    s2_fName: 'Name',
    s2_fNameDesc: 'Human-readable asset name (e.g. Air Compressor #3)',
    s2_fCode: 'Asset Code',
    s2_fCodeDesc: 'Unique internal reference (e.g. AC-003)',
    s2_fCategory: 'Category',
    s2_fCategoryDesc: 'Type of asset — Electrical, Mechanical, HVAC, etc.',
    s2_fBranch: 'Branch',
    s2_fBranchDesc: 'Which site this asset belongs to',
    s2_fLocation: 'Location',
    s2_fLocationDesc: 'Specific room or area within the branch',
    s2_fSerial: 'Serial Number',
    s2_fSerialDesc: 'Manufacturer serial number for warranty tracking',
    s2_fPurchase: 'Purchase Date',
    s2_fPurchaseDesc: 'Used to calculate asset age and warranty status',
    s2_fNextService: 'Next Service',
    s2_fNextServiceDesc: 'Scheduled date for the next maintenance visit',
    s2_note: 'Assets with components that are due for replacement appear highlighted in the CMMS Dashboard so you never miss a maintenance window.',
    s3_title: 'Work Orders',
    s3_subtitle: 'Create, assign, and track maintenance tasks.',
    s3_step1: 'Go to CMMS → Work Orders and click Create Work Order.',
    s3_step2: 'Select the asset, describe the issue, and set the priority (Low / Medium / High / Critical).',
    s3_step3: 'Assign it to a technician from your team.',
    s3_step4: 'Set an estimated completion date.',
    s3_step5: 'The assigned technician receives a notification and can update the status as they work.',
    s3_step6: 'Once resolved, the technician marks it Complete and adds a service note.',
    s3_statuses: 'Work order statuses',
    s3_open: 'Open',
    s3_openDesc: 'Newly created, not started',
    s3_inProgress: 'In Progress',
    s3_inProgressDesc: 'Technician is working on it',
    s3_onHold: 'On Hold',
    s3_onHoldDesc: 'Waiting for parts or approval',
    s3_completed: 'Completed',
    s3_completedDesc: 'Work finished and verified',
    s4_title: 'Preventive Maintenance',
    s4_subtitle: 'Automate recurring maintenance to prevent breakdowns.',
    s4_step1: 'Go to CMMS → PM Schedules and click Add Schedule.',
    s4_step2: 'Select the asset and describe the maintenance task (e.g. Oil Change).',
    s4_step3: 'Set the frequency — Daily, Weekly, Monthly, Quarterly, or Annually.',
    s4_step4: 'Assign a default technician to handle this task.',
    s4_step5: 'Save. The system will automatically generate a work order on each due date.',
    s4_note: 'PM Schedules that are due within the next 7 days are highlighted on the CMMS Dashboard widget so your team can prepare in advance.',
    s5_title: 'Inventory & Warehouses',
    s5_subtitle: 'Track spare parts and materials across all your storage locations.',
    s5_step1: 'Create warehouses under CMMS → Warehouses (each warehouse belongs to a branch).',
    s5_step2: 'Add inventory items under CMMS → Inventory — set the name, unit, quantity, and minimum stock level.',
    s5_step3: 'Assign each item to a warehouse.',
    s5_step4: 'When a work order is completed, the technician logs which parts were used — stock is decremented automatically.',
    s5_note: 'Items below their minimum stock level are flagged on the dashboard so you can re-order before running out.',
    s6_title: 'Team & Permissions',
    s6_subtitle: 'Invite team members and control what each role can see and do.',
    s6_step1: 'Go to CMMS → Team and click Invite Member.',
    s6_step2: 'Enter the member\'s email address and select their role.',
    s6_step3: 'The invitee receives an email with a link to set up their account.',
    s6_step4: 'Once they log in, they only see the sections their role allows.',
    s6_roles: 'CMMS roles',
    s6_roleCol: 'Role',
    s6_accessCol: 'Access Level',
    s6_admin: 'Admin',
    s6_adminDesc: 'Full access — can manage team, assets, work orders, reports, and settings',
    s6_supervisor: 'Supervisor',
    s6_supervisorDesc: 'View and manage all work orders; can create PM schedules; no billing access',
    s6_technician: 'Technician',
    s6_technicianDesc: 'View and update work orders assigned to them; no management access',
    s6_viewer: 'Viewer',
    s6_viewerDesc: 'Read-only access to assets and work orders for auditing purposes',
    s7_title: 'Reports & Analytics',
    s7_subtitle: 'Measure maintenance performance and identify patterns.',
    s7_intro: 'Navigate to CMMS → Reports to access built-in analytics. Reports can be exported as PDF or Excel.',
    s7_r1: 'Work Order Summary',
    s7_r1Desc: 'Total work orders by status (Open / In Progress / Completed), average resolution time, and overdue count.',
    s7_r2: 'Asset Health Report',
    s7_r2Desc: 'List of all assets with their last service date, next scheduled maintenance, and open work orders.',
    s7_r3: 'Technician Performance',
    s7_r3Desc: 'Work orders completed per technician, average time to resolution, and overdue assignments.',
    s7_r4: 'PM Compliance',
    s7_r4Desc: 'Percentage of preventive maintenance tasks completed on time vs. overdue across all branches.',
    s7_r5: 'Inventory Usage',
    s7_r5Desc: 'Parts consumed per period, stock levels, and items approaching the minimum threshold.',
    needHelp: 'Need Help?',
    needHelpSubtitle: 'Our support team is ready to assist you with your CMMS setup.',
    backToDocs: '← Back to Docs',
    contactSupport: 'Contact Support',
  },

  // Help Page
  helpPage: {
    title: 'Help Center',
    subtitle: 'Find answers and get support',
    getInTouch: 'Get in Touch',
    faqTitle: 'Frequently Asked Questions',
    stillNeedHelp: 'Still Need Help?',
    stillNeedHelpDesc: 'Our support team is available 24/7 to assist you',
    contactSupport: 'Contact Support',
    contact1Title: 'Live Chat',
    contact1Desc: 'Chat with our support team in real-time',
    contact1Action: 'Start Chat',
    contact1Available: 'Available 24/7',
    contact2Title: 'Email Support',
    contact2Desc: "We'll respond within 24 hours",
    contact2Action: 'Send Email',
    contact2Available: 'support@mwbtechs.com',
    contact3Title: 'Phone Support',
    contact3Desc: 'Call us for immediate assistance',
    contact3Action: 'Call Now',
    contact3Available: '+1 (555) 123-4567',
    contact4Title: 'Documentation',
    contact4Desc: 'Browse our comprehensive guides and tutorials',
    contact4Action: 'View Docs',
    contact4Available: 'Self-service resources',
    faq1Cat: 'Getting Started',
    faq1q1: 'How do I create an account?',
    faq1a1: 'Click the "Get Started" button and follow the registration process.',
    faq1q2: 'Can I see the platform before buying?',
    faq1a2: "Yes. Request a demo from the contact page and we'll walk you through it.",
    faq1q3: 'Do you offer a free trial?',
    faq1a3: 'No. We offer a guided demo instead, so you can see the platform in action before choosing a plan.',
    faq2Cat: 'Billing',
    faq2q1: 'How can I change my plan?',
    faq2a1: 'You can upgrade or downgrade your plan anytime from your account settings.',
    faq2q2: 'What payment methods do you accept?',
    faq2a2: 'We accept all major credit cards, PayPal, and bank transfers for annual plans.',
    faq2q3: 'Do you offer refunds?',
    faq2a3: 'Yes, we offer a 30-day money-back guarantee on all new subscriptions.',
    faq3Cat: 'Features',
    faq3q1: 'Can I import my existing data?',
    faq3a1: 'Yes, we support data import from CSV files and other CMMS systems.',
    faq3q2: 'Is there a mobile app?',
    faq3a2: 'Yes, we have mobile apps for both iOS and Android devices.',
    faq3q3: 'Can I integrate with other tools?',
    faq3a3: 'Yes, we offer integrations with popular tools and a robust API.',
  },

  privacy: {
    pageTitle: 'Privacy Policy | mwbTechs',
    metaDesc: 'Read mwbTechs Privacy Policy. Learn how we collect, use, and protect your personal information.',
    title: 'Privacy Policy',
    subtitle: 'Your privacy is important to us',
    lastUpdated: 'Last Updated: January 22, 2026',
    introTitle: 'Introduction',
    introText: 'mwbTechs ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website and services. Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, please do not access the site or use our services.',
    ctaTitle: 'Questions About Privacy?',
    ctaDesc: 'Our team is here to help. Contact us anytime with privacy-related questions.',
    ctaBtn: 'Contact Privacy Team',
    relTermsTitle: 'Terms of Service',
    relTermsDesc: 'Read our terms and conditions',
    relCookiesTitle: 'Cookie Policy',
    relCookiesDesc: 'Learn about our cookie usage',
    relSecurityTitle: 'Security',
    relSecurityDesc: 'How we protect your data',
    s1Title: '1. Information We Collect',
    s1Content: `<p class="mb-4">We collect information that you provide directly to us, including:</p><ul class="list-disc pl-6 mb-4 space-y-2"><li><strong>Account Information:</strong> Name, email address, company name, and password when you create an account</li><li><strong>Profile Information:</strong> Additional information you choose to provide in your profile</li><li><strong>Payment Information:</strong> Billing details and payment card information (processed securely by our payment providers)</li><li><strong>Communications:</strong> Information you provide when you contact us or participate in surveys</li><li><strong>Usage Data:</strong> Information about how you use our services, including log data, device information, and cookies</li></ul>`,
    s2Title: '2. How We Use Your Information',
    s2Content: `<p class="mb-4">We use the information we collect to:</p><ul class="list-disc pl-6 mb-4 space-y-2"><li>Provide, maintain, and improve our services</li><li>Process transactions and send related information</li><li>Send technical notices, updates, security alerts, and support messages</li><li>Respond to your comments, questions, and provide customer service</li><li>Monitor and analyze trends, usage, and activities</li><li>Detect, prevent, and address technical issues and fraudulent activity</li><li>Personalize and improve your experience</li><li>Send marketing communications (with your consent)</li></ul>`,
    s3Title: '3. Information Sharing and Disclosure',
    s3Content: `<p class="mb-4">We do not sell your personal information. We may share your information only in the following circumstances:</p><ul class="list-disc pl-6 mb-4 space-y-2"><li><strong>With Your Consent:</strong> We will share information with your explicit consent</li><li><strong>Service Providers:</strong> We may share information with third-party service providers who perform services on our behalf</li><li><strong>Legal Requirements:</strong> We may disclose information if required by law or in response to legal requests</li><li><strong>Business Transfers:</strong> Information may be transferred in connection with a merger, acquisition, or sale of assets</li><li><strong>Protection of Rights:</strong> To protect the rights, property, and safety of mwbTechs, our users, and the public</li></ul>`,
    s4Title: '4. Data Security',
    s4Content: `<p class="mb-4">We take the security of your information seriously and implement appropriate technical and organizational measures to protect it:</p><ul class="list-disc pl-6 mb-4 space-y-2"><li>Encryption of data in transit and at rest using industry-standard protocols</li><li>Regular security assessments and penetration testing</li><li>Access controls and authentication mechanisms</li><li>Employee training on data protection and security practices</li><li>Incident response procedures and breach notification protocols</li></ul><p class="mb-4">However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>`,
    s5Title: '5. Data Retention',
    s5Content: `<p class="mb-4">We retain your personal information for as long as necessary to:</p><ul class="list-disc pl-6 mb-4 space-y-2"><li>Provide our services to you</li><li>Comply with legal obligations</li><li>Resolve disputes and enforce our agreements</li></ul><p class="mb-4">When we no longer need your information, we will securely delete or anonymize it.</p>`,
    s6Title: '6. Your Rights and Choices',
    s6Content: `<p class="mb-4">You have certain rights regarding your personal information:</p><ul class="list-disc pl-6 mb-4 space-y-2"><li><strong>Access:</strong> Request access to the personal information we hold about you</li><li><strong>Correction:</strong> Request correction of inaccurate or incomplete information</li><li><strong>Deletion:</strong> Request deletion of your personal information</li><li><strong>Portability:</strong> Request a copy of your information in a portable format</li><li><strong>Opt-out:</strong> Unsubscribe from marketing communications at any time</li><li><strong>Cookies:</strong> Control cookies through your browser settings</li></ul><p class="mb-4">To exercise these rights, please contact us at privacy@mwbtechs.com.</p>`,
    s7Title: '7. Cookies and Tracking Technologies',
    s7Content: `<p class="mb-4">We use cookies and similar tracking technologies to collect and track information about your use of our services. You can control cookies through your browser settings. For more information, see our <a href="/cookies" class="text-primary-600 hover:underline">Cookie Policy</a>.</p>`,
    s8Title: '8. International Data Transfers',
    s8Content: `<p class="mb-4">Your information may be transferred to and processed in countries other than your country of residence. We ensure appropriate safeguards are in place to protect your information in accordance with this Privacy Policy.</p>`,
    s9Title: "9. Children's Privacy",
    s9Content: `<p class="mb-4">Our services are not intended for children under 16 years of age. We do not knowingly collect personal information from children under 16. If you believe we have collected information from a child under 16, please contact us immediately.</p>`,
    s10Title: '10. Changes to This Privacy Policy',
    s10Content: `<p class="mb-4">We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. We encourage you to review this Privacy Policy periodically.</p>`,
    s11Title: '11. Contact Us',
    s11Content: `<p class="mb-4">If you have any questions about this Privacy Policy, please contact us:</p><ul class="list-none space-y-2"><li><strong>Email:</strong> privacy@mwbtechs.com</li><li><strong>Address:</strong> 123 Tech Street, San Francisco, CA 94105, USA</li><li><strong>Phone:</strong> +1 (555) 123-4567</li></ul>`,
  },

  terms: {
    pageTitle: 'Terms of Service | mwbTechs',
    metaDesc: 'Read mwbTechs Terms of Service. Understand the terms and conditions for using our services.',
    title: 'Terms of Service',
    subtitle: 'Please read these terms carefully before using our services',
    lastUpdated: 'Last Updated: January 22, 2026',
    introTitle: 'Agreement to Terms',
    introText: 'These Terms of Service constitute a legally binding agreement between you and mwbTechs regarding your use of our website and services. By accessing or using our services, you acknowledge that you have read, understood, and agree to be bound by these terms.',
    ctaTitle: 'Questions About These Terms?',
    ctaDesc: 'Our legal team is available to answer any questions you may have.',
    ctaBtn: 'Contact Legal Team',
    relPrivacyTitle: 'Privacy Policy',
    relPrivacyDesc: 'How we protect your data',
    relCookiesTitle: 'Cookie Policy',
    relCookiesDesc: 'Learn about our cookie usage',
    relSecurityTitle: 'Security',
    relSecurityDesc: 'Our security practices',
    s1Title: '1. Acceptance of Terms',
    s1Content: `<p class="mb-4">By accessing and using mwbTechs services, you accept and agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree to these terms, please do not use our services.</p>`,
    s2Title: '2. Description of Services',
    s2Content: `<p class="mb-4">mwbTechs provides:</p><ul class="list-disc pl-6 mb-4 space-y-2"><li>CMMS (Computerized Maintenance Management System) software</li><li>AI-powered chatbot solutions</li><li>Digital transformation consulting services</li><li>Custom software development services</li><li>Related support and maintenance services</li></ul><p class="mb-4">We reserve the right to modify, suspend, or discontinue any part of our services at any time with reasonable notice.</p>`,
    s3Title: '3. Account Registration',
    s3Content: `<p class="mb-4">To use our services, you must:</p><ul class="list-disc pl-6 mb-4 space-y-2"><li>Be at least 18 years old or the age of majority in your jurisdiction</li><li>Provide accurate, current, and complete information during registration</li><li>Maintain and promptly update your account information</li><li>Keep your password secure and confidential</li><li>Notify us immediately of any unauthorized use of your account</li></ul><p class="mb-4">You are responsible for all activities that occur under your account.</p>`,
    s4Title: '4. Subscription and Billing',
    s4Content: `<p class="mb-4"><strong>4.1 Free Trial:</strong> We offer a 14-day free trial for new customers. No credit card is required to start a trial. You can cancel anytime during the trial period.</p><p class="mb-4"><strong>4.2 Paid Subscriptions:</strong> After the trial period, you will be charged according to your selected plan (monthly or annual). Fees are non-refundable except as required by law or as explicitly stated in these terms.</p><p class="mb-4"><strong>4.3 Automatic Renewal:</strong> Subscriptions automatically renew unless canceled before the renewal date. You will be charged using your selected payment method.</p><p class="mb-4"><strong>4.4 Price Changes:</strong> We may change our pricing with 30 days' notice. Changes will take effect at your next renewal date.</p><p class="mb-4"><strong>4.5 Refunds:</strong> We offer a 30-day money-back guarantee for new paid subscriptions. Contact us within 30 days of your first payment for a full refund.</p>`,
    s5Title: '5. Acceptable Use',
    s5Content: `<p class="mb-4">You agree not to:</p><ul class="list-disc pl-6 mb-4 space-y-2"><li>Use our services for any illegal purpose or in violation of any laws</li><li>Upload, transmit, or distribute any harmful code, viruses, or malicious software</li><li>Attempt to gain unauthorized access to our systems or other users' accounts</li><li>Interfere with or disrupt the integrity or performance of our services</li><li>Use our services to send spam or unsolicited communications</li><li>Scrape, copy, or reverse engineer our services</li><li>Resell or redistribute our services without authorization</li><li>Use our services in any way that could harm our reputation</li></ul>`,
    s6Title: '6. Intellectual Property',
    s6Content: `<p class="mb-4"><strong>6.1 Our IP:</strong> All content, features, and functionality of our services are owned by mwbTechs and are protected by copyright, trademark, and other intellectual property laws.</p><p class="mb-4"><strong>6.2 Your Content:</strong> You retain ownership of any content you submit to our services. By submitting content, you grant us a license to use, store, and display that content as necessary to provide our services.</p><p class="mb-4"><strong>6.3 Feedback:</strong> Any feedback, suggestions, or ideas you provide become our property and may be used without compensation or attribution.</p>`,
    s7Title: '7. Data and Privacy',
    s7Content: `<p class="mb-4">We collect and process your data as described in our <a href="/privacy" class="text-primary-600 hover:underline">Privacy Policy</a>. You are responsible for ensuring you have the right to submit any data to our services.</p><p class="mb-4">We implement industry-standard security measures, but cannot guarantee absolute security. You use our services at your own risk.</p>`,
    s8Title: '8. Service Level Agreement (SLA)',
    s8Content: `<p class="mb-4">We strive to maintain 99.9% uptime for our services, excluding scheduled maintenance. Details of our SLA are available in your service agreement or upon request for Enterprise customers.</p>`,
    s9Title: '9. Warranties and Disclaimers',
    s9Content: `<p class="mb-4"><strong>9.1 Services "As Is":</strong> Our services are provided "as is" and "as available" without warranties of any kind, either express or implied.</p><p class="mb-4"><strong>9.2 No Warranty:</strong> We do not warrant that our services will be uninterrupted, error-free, or completely secure.</p><p class="mb-4"><strong>9.3 Third-Party Services:</strong> We are not responsible for any third-party services or integrations you may use with our services.</p>`,
    s10Title: '10. Limitation of Liability',
    s10Content: `<p class="mb-4">To the maximum extent permitted by law:</p><ul class="list-disc pl-6 mb-4 space-y-2"><li>mwbTechs shall not be liable for any indirect, incidental, special, consequential, or punitive damages</li><li>Our total liability shall not exceed the amount you paid us in the 12 months preceding the claim</li><li>We are not liable for any loss of data, profits, or business opportunities</li></ul>`,
    s11Title: '11. Indemnification',
    s11Content: `<p class="mb-4">You agree to indemnify and hold harmless mwbTechs from any claims, damages, or expenses arising from your use of our services, violation of these terms, or infringement of any rights of another party.</p>`,
    s12Title: '12. Termination',
    s12Content: `<p class="mb-4"><strong>12.1 By You:</strong> You may cancel your subscription at any time through your account settings or by contacting us.</p><p class="mb-4"><strong>12.2 By Us:</strong> We may suspend or terminate your account if you violate these terms, fail to pay fees, or for any other reasonable cause with appropriate notice.</p><p class="mb-4"><strong>12.3 Effect of Termination:</strong> Upon termination, your right to use our services ceases immediately. We may delete your data after a reasonable period.</p>`,
    s13Title: '13. Governing Law',
    s13Content: `<p class="mb-4">These terms shall be governed by the laws of the State of California, USA, without regard to its conflict of law provisions. Any disputes shall be resolved in the courts of San Francisco County, California.</p>`,
    s14Title: '14. Changes to Terms',
    s14Content: `<p class="mb-4">We may update these terms from time to time. We will notify you of material changes via email or through our services. Your continued use after changes constitutes acceptance of the new terms.</p>`,
    s15Title: '15. Contact Information',
    s15Content: `<p class="mb-4">For questions about these terms, contact us:</p><ul class="list-none space-y-2"><li><strong>Email:</strong> legal@mwbtechs.com</li><li><strong>Address:</strong> 123 Tech Street, San Francisco, CA 94105, USA</li><li><strong>Phone:</strong> +1 (555) 123-4567</li></ul>`,
  },

  security: {
    pageTitle: 'Security | mwbTechs',
    metaDesc: 'Learn about mwbTechs security practices and how we protect your data.',
    title: 'Security',
    subtitle: 'Enterprise-grade security to protect your data',
    m1Title: 'Encryption',
    m1Desc: 'All data is encrypted in transit (TLS 1.3) and at rest (AES-256) using industry-standard protocols.',
    m2Title: 'Secure Infrastructure',
    m2Desc: 'Hosted on enterprise-grade cloud infrastructure with SOC 2 Type II compliance and regular security audits.',
    m3Title: 'Access Controls',
    m3Desc: 'Multi-factor authentication, role-based access control, and comprehensive audit logging.',
    m4Title: 'Regular Testing',
    m4Desc: 'Continuous vulnerability scanning, penetration testing, and security assessments by third-party experts.',
    certTitle: 'Certifications & Compliance',
    cert1: 'SOC 2 Type II Certified',
    cert2: 'GDPR Compliant',
    cert3: 'ISO 27001 Certified',
    cert4: 'HIPAA Compliant (Enterprise)',
    cert5: 'PCI DSS Compliant',
    reportTitle: 'Report Security Issues',
    reportDesc: 'If you discover a security vulnerability, please report it to us immediately at security@mwbtechs.com. We take all security reports seriously and will respond promptly.',
    reportBtn: 'Report Issue',
    relPrivacyTitle: 'Privacy Policy',
    relTermsTitle: 'Terms of Service',
  },

};

export default en;
